import { Settings, useSettings } from '@/context/settings';
import { NumberFormatOptions } from 'use-intl';
import useEthereumPrice from '@/application/read/price/useEthereumPrice';
import Price from './Price';

export interface PriceProps extends NumberFormatOptions {
  value?: bigint;
  currency?: Settings['currency'];
  showEmpty?: boolean;
}

const PriceContainer = ({
  value,
  currency: currencyOverride,
  showEmpty,
  ...opts
}: PriceProps) => {
  const [settings] = useSettings();
  const currency = currencyOverride ?? settings.currency;

  const { data: ethPrice } = useEthereumPrice({
    enabled: currency === 'USD',
  });

  if (value == null && !showEmpty) return null;

  return (
    <Price
      currency={currency}
      ethPrice={ethPrice}
      value={value ?? 0n}
      {...opts}
    />
  );
};

export default PriceContainer;
